import React from "react";
import { Card, CardContent } from "@/components/ui/card";

/** Structure-only stub (Phase 4 scope) -- functional UI is a separate backlog item. */
export function NotificationsTab() {
  return (
    <Card className="max-w-2xl">
      <CardContent className="p-6">
        <p className="text-sm text-gray-500">Notification preferences are coming soon.</p>
      </CardContent>
    </Card>
  );
}
